import { createAction } from '@reduxjs/toolkit'

export const SCHEDULE_LOAD = 'SCHEDULE_LOAD'
export const SCHEDULE_LOAD_FOR_CLASSES = 'SCHEDULE_LOAD_FOR_CLASSES'
export const SCHEDULE_SAVE_LESSON = 'SCHEDULE_SAVE_LESSON'
export const SCHEDULE_DELETE_LESSON = 'SCHEDULE_DELETE_LESSON'
export const SCHEDULE_CHECK_OCCUPANCY = 'SCHEDULE_CHECK_OCCUPANCY'

export const scheduleLoad = createAction(SCHEDULE_LOAD)
export const scheduleLoadForClasses = createAction(SCHEDULE_LOAD_FOR_CLASSES)
export const scheduleSaveLesson = createAction(SCHEDULE_SAVE_LESSON)
export const scheduleDeleteLesson = createAction(SCHEDULE_DELETE_LESSON)
export const scheduleCheckOccupancy = createAction(SCHEDULE_CHECK_OCCUPANCY)
